import React from 'react'
import { Grid, PageSection as Section, PageHeader } from '@superhi/design'

import AboutCallout from '../../components/AboutCallout'

import ROUTE from './route'
import { Props } from './data'

import Aside from 'src/components/Aside'
import Main from 'src/components/Main'
import Page from 'src/components/Page'
import Data from 'src/components/Data'
import NoResults from 'src/components/NoResults'
import SEO from 'src/components/SEO'
import JobCard from 'src/components/JobCard'
import { PageConfig } from 'src/routing/types'

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 6,
}

const Jobs: PageConfig<Props> = ({ jobs: jobItems }) => {
  return (
    <Page>
      <SEO title="Jobs" description="Open positions for a career at SuperHi." />

      <Main>
        <PageHeader title="Jobs" backgroundVersion="BLUE_02" />

        <Section>
          <Grid alignItems="stretch">
            <Data
              data={jobItems?.nodes!}
              loading={false}
              whenEmpty={
                <Grid.Cell span="full">
                  <NoResults hAlign="center">
                    Unfortunately we have no open roles at the moment. Check back soon!
                  </NoResults>
                </Grid.Cell>
              }
            >
              {(jobs) => (
                <>
                  {jobs.map((job) => (
                    <Grid.Cell key={job.slug} span={GRID_1_CELL_SPAN_1}>
                      <JobCard {...job} />
                    </Grid.Cell>
                  ))}
                </>
              )}
            </Data>
          </Grid>
        </Section>

        <Aside>
          <AboutCallout />
        </Aside>
      </Main>
    </Page>
  )
}

Jobs.route = ROUTE

export { getStaticProps } from './data'
export default Jobs
